import { create } from 'zustand';
import { ApiUtils, RequestStrategyEnum } from '@shared/utils';
import { CardsApi, type ApplyCardRequest } from '@shared/api';

interface ApplyFormType {
  success: boolean;
  loading: boolean;
  error: string | null;
  applyForm: (data: ApplyCardRequest, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useApplyFormStore = create<ApplyFormType>((set) => ({
  success: false,
  loading: false,
  error: null,

  applyForm: ApiUtils.wrapperApi(async (data, signal) => {
    try {
      set({ loading: true, error: null, success: false });
      await CardsApi.applyCard(data, signal);
      set({ success: true, loading: false });
    } catch (error) {
      set({ error: ApiUtils.getApiError(error), loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ success: false, loading: false, error: null }),
}));
